export default "__VITE_ASSET__D7y4_JYo__"